import { GetAuthToken } from './GetAuthToken.js';

/**
 * Gets data at the specified location using a shallow GET request using the user's id token for authentication
 * WARNING: The keys returned by this function are not sorted. You must sort them if order matters. For example,
 * you are making a startAfter follow-up request to start after the last key
 * @param {string} path - the path to get
 * @param {string} [databaseURL] - an override of the database URL to use. Otherwise, the global config will be used
 * @param {object} [queryParameters] - an object with keys for each query parameter to include and values for the value of each query parameter
 * @param {number} [queryParameters.limitToFirst] - the number of first ordered keys to return
 * @param {string} [queryParameters.startAfter] - the key to start the query at
 * @returns {Promise<object|null>} returns null if there is no data, otherwise an object of keys at the location is returned
 * @throws {Error} throws an error if the user does not have permission to the path
 */
export async function ShallowGet(path, databaseURL, queryParameters) {
  databaseURL = databaseURL || self.config?.firebaseConfigs?.[self.config?.appName]?.databaseURL;
  const tokenResult = await GetAuthToken();
  const authParameter = tokenResult?.type == 'id_token' ? 'auth' : 'access_token';
  const queryParametersString = Object.entries(queryParameters || {})
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  let result = await fetch(
    `${databaseURL}/${path}.json?shallow=true${queryParametersString ? `&${queryParametersString}` : ''}&${authParameter}=${tokenResult?.token}`
  ).then((response) => response.json());
  if (result?.error == 'Permission denied') {
    throw `Error: Permission denied at ${path}`;
  }
  return result;
}
